export function getSum(arr: Array<number>): number {
  return arr.reduce((accumulator, value) => accumulator + value, 0);
}
